import Vue from 'vue';

/** Event bus for sending XOMEs events. */
const XomesEventBus = new Vue();

export default XomesEventBus;
